import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import {
	lobbyPeersValueSelector,
	makePermissionSelector
} from '../../Selectors';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { permissions } from '../../../permissions';
import * as appPropTypes from '../../appPropTypes';
import { withRoomContext } from '../../../RoomContext';
import * as roomActions from '../../../actions/roomActions';
import * as bottomNavigationActions from '../../../actions/bottomNavigationActions';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';

// Component
import { firestore } from '../../../lib/firebase';

// Constants
import {
	ROOM_ONLINE,
	ROOM_CALLING,
	CALL_STATUS_CATCH,
	CALL_STATUS_SKIP
} from '../../../const';

const styles = (theme) =>
	({
		root :
		{
			zIndex   : 99,
			width    : '100%',
			height   : '100%',
			position : 'fixed'
		},
		dialogPaper :
		{
			padding                        : '1% 1%',
			width                          : '20vw',
			height                         : 'fit-content',
			[theme.breakpoints.down('lg')] :
			{
				width : '20vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '25vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '90vw'
			},
			backgroundColor : '#666666'
		},
		lock :
		{
			padding : theme.spacing(2)
		},
		title :
		{
			width         : '100%',
			display       : 'flex',
			flexDirection : 'column',
			alignItems    : 'center'
		},
		titleIcon :
		{
			width     : '4rem',
			height    : '4rem',
			transform : 'scaleX(-1)'
		},
		titleText :
		{
			color    : 'white',
			fontSize : '0.8rem'
		},
		promoteBtn :
		{
			width           : '40%',
			border          : '1px solid #8eba14',
			backgroundColor : '#8eba14',
			color           : 'white'
		},
		cancelBtn :
		{
			width           : '40%',
			border          : '1px solid #fff',
			backgroundColor : 'transparent',
			color           : 'white'
		},
		timeout :
		{
			border          : '1px solid #8eba14',
			borderRadius    : '0.5rem',
			backgroundColor : '#8eba14',
			width           : '100%',
			textAlign       : 'center',
			fontSize        : '1.5rem',
			marginBottom    : '20%',
			padding         : '0.1rem 0'
		},
		serviceName :
		{
			border          : '1px solid #fff',
			borderRadius    : '0.5rem',
			backgroundColor : '#fff',
			width           : '100%',
			textAlign       : 'center',
			fontSize        : '0.9rem',
			marginBottom    : '10%',
			padding         : '0.4rem 0',
			color           : '#666666'
		},
		osInfo :
		{
			display        : 'flex',
			justifyContent : 'space-between',
			width          : '100%',
			borderBottom   : '1px solid #fff',
			fontSize       : '0.9rem',
			marginBottom   : '10%'
		},
		browserInfo :
		{
			display        : 'flex',
			justifyContent : 'space-between',
			width          : '100%',
			borderBottom   : '1px solid #fff',
			fontSize       : '0.9rem',
			marginBottom   : '10%'
		}
	});

const theme = createTheme({
	overrides : {
		MuiBackdrop : {
			root : {
				backgroundColor : 'transparent'
			}
		},
		MuiDialogTitle : {
			root : {
				backgroundColor : 'transparent',
				color           : '#9ec317',
				width           : '100%'
			}
		},
		MuiDialogContent : {
			root : {
				color          : 'white',
				justifyContent : 'center',
				display        : 'flex',
				flexDirection  : 'column',
				alignItems     : 'center'
			}
		},
		MuiDialogActions : {
			root : {
				justifyContent : 'space-around'
			}
		},
		MuiTypography : {
			colorTextSecondary : {
				color : 'white'
			}
		},
		MuiPaper : {
			rounded : {
				borderRadius : '0.6rem'
			}
		}
	}
});

let timer = null;

const OnCallDialog = ({
	roomClient,
	room,
	handleCloseOnCallDialog,
	lobbyPeers,
	canPromote,
	classes,
	user,
	setNaviTab,
	currentNaviTab,
	setRoomCall,
	setRoomCallStartTime,
	settings
}) =>
{
	const [ serviceName, setServiceName ] = useState('');
	const [ timeoutRemain, setRemainTime ] = useState(settings.callNum);
	const [ acceptButtonPressed, setAcceptButtonPressed ] = useState(false);

	const setRoomStatus = useCallback((status) =>
	{
		// ステータスを待機中に設定
		firestore.collection('rooms').doc(room.name)
			.update({
				status : status
			})
			.catch((e) =>
			{
				console.error(e); // eslint-disable-line no-console
			});
	}, [ room.name ]);

	const uploadCallInfo = useCallback(async (status) =>
	{
		if (room.info === null
			|| lobbyPeers.length === 0
			|| lobbyPeers[0].guestInputs === undefined
			|| lobbyPeers[0].os === undefined
			|| lobbyPeers[0].browser === undefined
		)
		{
			return;
		}

		// eslint-disable-next-line no-console
		console.log('CallMemo lobbyPeers:', lobbyPeers[0]);

		const id = `${room.info.uid}_${lobbyPeers[0].id}`;

		// ステータスを待機中に設定
		const doc = await firestore.collection('calls').doc(id)
			.get();

		let data = null;

		// ステータスを待機中に設定
		if (doc.exists)
		{
			data = doc.data();
			data.timestamp = Date.now();
			data.duration = 0;
			data.status = status;
			data.calls.push({
				timestamp : Date.now(),
				user      : room.info.user,
				roomId    : room.info.id,
				status    : status
			});

			await firestore.collection('calls').doc(id)
				.update(data)
				.catch((e) =>
				{
					console.error(e); // eslint-disable-line no-console
				});
		}
		else
		{
			data = {
				timestamp   : Date.now(),
				os          : lobbyPeers[0].os,
				browser     : lobbyPeers[0].browser,
				guestInput1 : lobbyPeers[0].guestInputs.guestInput1,
				guestInput2 : lobbyPeers[0].guestInputs.guestInput2,
				duration    : 0,
				status      : status,
				uid         : room.info.uid,
				calls       : [ {
					timestamp : Date.now(),
					user      : room.info.user,
					roomId    : room.info.id,
					status    : status
				} ]
			};

			await firestore.collection('calls').doc(id)
				.set(data)
				.catch((e) =>
				{
					console.error(e); // eslint-disable-line no-console
				});
		}

		// setRoomCall information
		if (status === CALL_STATUS_CATCH)
		{
			data.id = id;
			setRoomCall({
				...data
			});
		}
		else
		{
			setRoomCall(null);
		}

	}, [ room.info, lobbyPeers, setRoomCall ]);

	const handleSkip = () =>
	{
		setRemainTime(0);
	};

	const handleAccept = useCallback(async () =>
	{
		setAcceptButtonPressed(true);
		// update status
		await uploadCallInfo(CALL_STATUS_CATCH);
		// accept
		await roomClient.promoteAllLobbyPeers();
		// setRoomStatus(ROOM_TALKING);
		if (currentNaviTab !== 'home')
		{
			setNaviTab('home');
		}
		// set call start time
		setRoomCallStartTime(Date.now());
		// hide dialog
		handleCloseOnCallDialog(false);
		setAcceptButtonPressed(false);
	}, [
		roomClient,
		currentNaviTab,
		setNaviTab,
		handleCloseOnCallDialog,
		uploadCallInfo,
		setRoomCallStartTime,
		setAcceptButtonPressed
	]);

	useEffect(() =>
	{
		setServiceName(user.serviceName);
	}, [ user ]);

	useEffect(() =>
	{
		let unmounted = false;

		const timeoutRemainNext = timeoutRemain - 1;

		if (timeoutRemainNext >= 0)
		{
			if (!unmounted)
			{
				roomClient._soundNotification();
				timer = setTimeout(() =>
				{
					setRemainTime(timeoutRemainNext);
				}, 1000);
			}
		}

		return () =>
		{
			if (timer)
			{
				clearTimeout(timer);
				timer = null;
			}
			unmounted = true;
		};
	}, [ roomClient, timeoutRemain, setRemainTime ]);

	useEffect(() =>
	{
		if (timeoutRemain === settings.callNum)
		{
			setRoomStatus(ROOM_CALLING);
		}
		else if (timeoutRemain === 0)
		{
			if (lobbyPeers && lobbyPeers[0])
			{
				roomClient.kickLobbyPeer(lobbyPeers[0].id);
			}
			roomClient._soundNotificationStop();
			// update status
			uploadCallInfo(CALL_STATUS_SKIP);
			setRoomStatus(ROOM_ONLINE);
			handleCloseOnCallDialog(false);
		}
	}, [
		timeoutRemain,
		roomClient,
		lobbyPeers,
		handleCloseOnCallDialog,
		uploadCallInfo,
		settings.callNum,
		setRoomStatus
	]);

	return (
		<MuiThemeProvider theme={theme}>
			<Dialog
				className={classes.root}
				open={room.callDialogOpen}
				onClose={() => {}}
				classes={{
					paper : classes.dialogPaper
				}}
			>
				<DialogTitle id='form-dialog-title'>
					<div className={classes.title}>
						<PhoneInTalkIcon className={classes.titleIcon}/>
						<div className={classes.titleText}>着信中</div>
					</div>
				</DialogTitle>
				{ lobbyPeers.length > 0 ?
					<DialogContent>
						<div className={classes.timeout}>
							{timeoutRemain}
						</div>
						<div className={classes.serviceName}>
							{serviceName}
						</div>
						<div className={classes.osInfo}>
							<p>OS</p>
							<p>{lobbyPeers[0].os}</p>
						</div>
						<div className={classes.browserInfo}>
							<p>ブラウザ</p>
							<p>{lobbyPeers[0].browser}</p>
						</div>
					</DialogContent>
					:
					<DialogContent>
						<DialogContentText gutterBottom>
							<FormattedMessage
								id='room.lobbyEmpty'
								defaultMessage='There are currently no one in the lobby'
							/>
						</DialogContentText>
					</DialogContent>
				}
				<DialogActions>
					<Button
						className={classes.promoteBtn}
						disabled={
							lobbyPeers.length === 0 ||
							!canPromote ||
							room.lobbyPeersPromotionInProgress
							|| acceptButtonPressed
						}
						onClick={handleAccept}
						color='primary'
					>
						<FormattedMessage
							id='label.promoteAllPeers'
							defaultMessage='Promote all'
						/>
					</Button>
					<Button
						className={classes.cancelBtn}
						onClick={handleSkip} color='primary'
					>
						{ lobbyPeers.length > 0 ?
							<FormattedMessage
								id='label.skip'
								defaultMessage='Skip'
							/>
							:
							<FormattedMessage
								id='label.close'
								defaultMessage='Close'
							/>
						}
					</Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider>
	);
};

OnCallDialog.propTypes =
{
	roomClient              : PropTypes.object.isRequired,
	room                    : appPropTypes.Room.isRequired,
	handleCloseOnCallDialog : PropTypes.func.isRequired,
	handleAccessCode        : PropTypes.func.isRequired,
	lobbyPeers              : PropTypes.array,
	canPromote              : PropTypes.bool,
	classes                 : PropTypes.object.isRequired,
	user                    : PropTypes.object.isRequired,
	setNaviTab              : PropTypes.func.isRequired,
	currentNaviTab          : PropTypes.string.isRequired,
	setRoomCall             : PropTypes.func.isRequired,
	setRoomCallStartTime    : PropTypes.func.isRequired,
	settings                : PropTypes.object.isRequired
};

const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.PROMOTE_PEER);

	const mapStateToProps = (state) =>
	{
		return {
			room           : state.room,
			lobbyPeers     : lobbyPeersValueSelector(state),
			canPromote     : hasPermission(state),
			user           : state.me.user,
			currentNaviTab : state.bottomNavigation.currentNaviTab,
			settings       : state.me.settings
		};
	};

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		handleCloseOnCallDialog : (flag) =>
		{
			dispatch(roomActions.setOnCallDialogOpen(flag));
		},
		handleAccessCode : (code) =>
		{
			dispatch(roomActions.setAccessCode(code));
		},
		setRoomCall : (call) =>
		{
			dispatch(roomActions.setRoomCall(call));
		},
		setRoomCallStartTime : (timestamp) =>
		{
			dispatch(roomActions.setRoomCallStartTime(timestamp));
		},
		setNaviTab : (tab) =>
		{
			dispatch(bottomNavigationActions.setNaviTab(tab));
		}
	};
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.me.roles === next.me.roles &&
				prev.me.user === next.me.user &&
				prev.me.settings === next.me.settings &&
				prev.peers === next.peers &&
				prev.lobbyPeers === next.lobbyPeers &&
				prev.bottomNavigation.currentNaviTab === next.bottomNavigation.currentNaviTab
			);
		}
	}
)(withStyles(styles)(OnCallDialog)));